<template>
  <ui-dropper text="Connected sessions" head-classes="flex gap-2" @opened="methodLoadConnectedUsers">
    <template #head>
      <i class="fa fa-users text-sky-600" />
      <span class="font-bold">Connected Users</span>
      <span class="text-right flex-grow" v-text="Object.keys(dataConnectedUsers || {}).length + ' user(s)'"/>
      <span class="px-2 py-1 border ui-rounded" @click.stop.prevent.capture="methodLoadConnectedUsers">
        <i
          class="fa fa-sync text-secondary"
          :class="{
            'animate-spin': dataLoading
          }"
          />
      </span>
    </template>

    <div v-if="dataConnectedUsers" class="border border-t-0 p-2 space-y-2 shadow-inner">
      <div v-if="Object.values(dataConnectedUsers).filter((v) => v?.id )?.length">
        <h5>Users</h5>
        <div
          v-for="(connectedUser,i) in Object.values(dataConnectedUsers).filter((v) => v?.id )"
          :key="'connected_user_'+i"
          class="flex gap-1 items-center"
          >
          <div class="flex flex-col flex-grow" :title="'Guest visitor id: '+connectedUser?.visitor_id">
            <div class="flex gap-1 items-center flex-grow">
              <ui-flag
                :iso="connectedUser?.locale ?? 'en'"
                class="max-w-3 rounded-sm"
                />
              <span v-text="connectedUser.firstname" />
              <span v-text="connectedUser.lastname" />
              <span class="flex-grow text-right" v-text="connectedUser.email"/>
            </div>
            <div class="flex gap-1 text-sm text-gray-400">
              <ui-category-badge class="!text-[10px] !p-0 !px-2" :text="connectedUser.device_os" />
              <ui-category-badge class="!text-[10px] !p-0 !px-2" :text="connectedUser.device_browser" />
              <span class="flex-grow text-right" v-text="moment(connectedUser.device_last_used_at).format('YY-MM-DD HH:mm')" />
            </div>
          </div>
          <ui-button
            class="dark dense"
            text="Chat"
            @click="methodCreateChat(connectedUser.device_id)"
            />
        </div>
      </div>

      <div v-if="Object.values(dataConnectedUsers).filter((v) => !v?.id )?.length">
        <h5>Guests</h5>
        <div
          v-for="(connectedGuest,i) in Object.values(dataConnectedUsers).filter((v) => !v?.id )"
          :key="'connected_guest_'+i"
          class="flex justify-between items-center gap-2"
          >
          <div class="flex flex-col flex-grow" :title="'Guest visitor id: '+connectedGuest?.visitor_id">
            <div class="flex gap-1 items-center flex-grow">
              <ui-flag
                :iso="connectedGuest?.locale ?? 'en'"
                class="max-w-3 rounded-sm"
                />
              <span v-text="connectedGuest.firstname" />
              <span v-text="connectedGuest.lastname" />
              <span v-text="connectedGuest.device_id" />
              <span class="flex-grow text-right" v-text="connectedGuest.email"/>
            </div>
            <div class="flex gap-1 text-sm text-gray-400">
              <ui-category-badge class="!text-[10px] !p-0 !px-2" :text="connectedGuest.device_os" />
              <ui-category-badge class="!text-[10px] !p-0 !px-2" :text="connectedGuest.device_browser" />
              <span class="flex-grow text-right" v-text="moment(connectedGuest.device_last_used_at).format('YY-MM-DD HH:mm')" />
            </div>
          </div>
          <ui-button
            class="dark dense"
            text="Chat"
            @click="methodCreateChat(connectedGuest?.device_id)"
            />
        </div>
      </div>
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
import moment from 'moment'

const modelSession = defineModel<string|null>('session')
const modelPopup = defineModel<boolean>('popup')

const dataConnectedUsers = ref<Record<string,any|null>>()
const dataLoading = ref<boolean>(false)

let intervalChecker: any = null;

onMounted(() => {
  methodLoadConnectedUsers()

  intervalChecker = setInterval(() => {
    methodLoadConnectedUsers()
  }, 3000)
})

onUnmounted(() => {
  if (intervalChecker) {
    clearInterval(intervalChecker)
  }
})

const methodLoadConnectedUsers = () => {
  if(!modelPopup.value) return
  if(modelSession.value) return

  dataLoading.value = true
  ws.send('support.connectedUsers').then((r) => {
    dataConnectedUsers.value = r
  }).finally(() => {
    setTimeout(() => {
      dataLoading.value = false
    }, 500)
  })
}

const methodCreateChat = (device_id: number|string) => {
  ws.send('support.create',{
    device_id
  }).then((r) => {
    modelSession.value = r.session
  })
}

watch(modelSession, methodLoadConnectedUsers)
watch(modelPopup, methodLoadConnectedUsers)
</script>
